/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 28/12/2023
 */

import { apiSlice } from '../Slices/apiSlice';

export const ProfileService = apiSlice.injectEndpoints({
    endpoints: builder => ({

        getProfileDetails: builder.query({
            query: () => `/sec-users/auth`,
            providesTags: ['profile']
        }),

        updateProfile: builder.mutation({
            query: (details) => ({
                url: `/sec-users/edit-sec-user`,
                method: 'PUT',
                body: details
            }),
            invalidatesTags: ['profile']
        }),

        deleteProfile: builder.mutation({
            query: (details) => ({
                url: `/sec-users/delete-user`,
                method: 'DELETE',
                body: details
            }),
            invalidatesTags: ['profile']
        }),

    })
});

export const {
    useGetProfileDetailsQuery,
    useLazyGetProfileDetailsQuery,
    useUpdateProfileMutation,
    useDeleteProfileMutation
} = ProfileService;